import {
  DomesticUltimateOwner,
  GlobalUltimateOwner,
} from "react-migration/domains/ownership/components/TitleOwner";
import { SimpleTitleOwnership } from "react-migration/domains/ownership/typings";
import { useTranslation } from "react-migration/lib";

export const UltimateOwnershipInformation = ({ owner }: { owner: SimpleTitleOwnership }) => {
  const { t } = useTranslation();

  if (!owner || (!owner.global_ultimate_owner && !owner.domestic_ultimate_owner)) {
    return null;
  }

  return (
    <div
      className="atlas-border-b atlas-border-border-divider atlas-mb-4"
      data-testid="ownership-overview-ultimate-owner"
    >
      <span className="atlas-font-semibold atlas-text-xl atlas-text-content-primary">
        {t("sites.card.ownership.ownership_information")}
      </span>
      <div className="atlas-pb-2 atlas-pt-1">
        <GlobalUltimateOwner ultimateOwner={owner.global_ultimate_owner} />
        <DomesticUltimateOwner ultimateOwner={owner.domestic_ultimate_owner} />
      </div>
    </div>
  );
};
